import React, { useState } from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTravelMessage, setShowTravelMessage] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="logo-top">
        <img
          src="/bit-logo.png"
          alt="BIT Logo"
          onClick={() => window.open("https://bitmesra.ac.in", "_blank")}
          style={{ cursor: "pointer" }}
        />
        <img src="logo_image.png" alt="BIT Logo" />
        <img src="/atlantis_1.png" alt="BIT Logo" />
        <img src="/70years.png" alt="BIT Logo" />
      </div>

      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>ICETTACS 2026</h1>
          </div>

          <div className={`nav-menu ${isOpen ? "active" : ""}`}>
            <a href="#home" className="nav-link" onClick={handleLinkClick}>
              Home
            </a>

            <a
              href="#about-conference"
              className="nav-link"
              onClick={handleLinkClick}
            >
              About Conference
            </a>

            <a href="#tracks" className="nav-link" onClick={handleLinkClick}>
              Tracks
            </a>

            <a
              href="#important-dates"
              className="nav-link importantDates"
              onClick={handleLinkClick}
            >
              Important Dates
            </a>

            <a
              href="#registration"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Registration
            </a>

            <button
              type="button"
              className="nav-link"
              onClick={() => {
                setShowTravelMessage(true);
                setIsOpen(false);
              }}
            >
              Logistics
            </button>

            <a
              href="#peer-review"
              className="nav-link peer-review"
              onClick={handleLinkClick}
            >
              Peer-Review
            </a>

            <a
              href="/papers.html"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Call for Papers
            </a>

            <a
              href="#committee"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Committee
            </a>

            <a
              href="#committee"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Speakers
            </a>
          </div>

          <div className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>

      {/* Travel & Accommodation Popup */}
      {showTravelMessage && (
        <div className="coming-soon-popup">
          <div className="popup-content">
            <h2>📌 Travel & Accommodation Notice</h2>

            <p>
              Travel and accommodation assistance is not available from the
              conference host. Participants are requested to make their own
              travel, lodging, and local transportation arrangements.
            </p>

            <button onClick={() => setShowTravelMessage(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;

